/// <amd-module name="SuiteCommerce.Blog.Post.Header.Image.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Header.Image.View", ["require", "exports", "Backbone", "sc_blog_post_header_image.tpl"], function (require, exports, Backbone_1, headerImageTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostHeaderImageView = /** @class */ (function (_super) {
        __extends(PostHeaderImageView, _super);
        function PostHeaderImageView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = headerImageTemplate;
            _this.model.on('change', function () {
                _this.render();
            });
            return _this;
        }
        PostHeaderImageView.prototype.getContext = function () {
            return {
                headerImageAlt: this.model.headerImageAlt,
                headerImageResizeName: this.model.headerImageResizeName,
                headerImageURL: this.model.headerImageURL,
            };
        };
        return PostHeaderImageView;
    }(Backbone_1.View));
    exports.PostHeaderImageView = PostHeaderImageView;
});
